import { he } from './he';
import { en } from './en';
import { ar } from './ar';
import type { Language, Translations } from '../types';

export const translations: Record<Language, Translations> = {
  he,
  en,
  ar,
};

export { he, en, ar };
